import { RefObject } from 'react'

import MessageBubble from './MessageBubble'

interface Message {
  text: string
  isUser: boolean
  timestamp?: string
  patientProfilePicture?: string | null
}

interface MessageListProps {
  messages: Message[]
  isBotTyping: boolean
  messagesContainerRef: RefObject<HTMLDivElement>
}

const MessageList = ({ messages, isBotTyping, messagesContainerRef }: MessageListProps) => {
  return (
    <div ref={messagesContainerRef} className='flex-1 overflow-y-auto p-4 bg-[#F1F1F1]'>
      {messages.map((message, index) => (
        <MessageBubble
          key={index}
          text={message.text}
          isUser={message.isUser}
          timestamp={message.timestamp}
          patientProfilePicture={message.patientProfilePicture}
        />
      ))}
      {isBotTyping && (
        <div className='mb-4 flex justify-start'>
          <div className='flex flex-col'>
            <div
              className={`
              relative max-w-[80%] rounded-[20px] rounded-bl-sm bg-white p-3
            `}
            >
              <div className='flex items-center gap-1'>
                <div
                  className='h-2 w-2 animate-bounce rounded-full bg-[linear-gradient(90deg,#E1B2D2_0%,#BAE4F2_100%)]'
                  style={{ animationDelay: '0s' }}
                ></div>
                <div
                  className='h-2 w-2 animate-bounce rounded-full bg-[linear-gradient(90deg,#E1B2D2_0%,#BAE4F2_100%)]'
                  style={{ animationDelay: '0.2s' }}
                ></div>
                <div
                  className='h-2 w-2 animate-bounce rounded-full bg-[linear-gradient(90deg,#E1B2D2_0%,#BAE4F2_100%)]'
                  style={{ animationDelay: '0.4s' }}
                ></div>
              </div>
              <div
                className={`
                  absolute bottom-0 left-[-8px] h-4 w-4 rounded-br-[10px]
                  bg-[#F1F1F1]
                `}
                style={{
                  clipPath: 'polygon(100% 0, 0% 100%, 100% 100%)',
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default MessageList
